import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import CelexInstitutionView from './screens/CelexInstitutionView';
import CelexNPIView from './screens/CelexNPIView';
import QuartalView from './screens/QuartalView';
import SearchRegister from './screens/SearchRegister';
import Sidebar from '../SideBar';
import { ReactComponent as Propisi } from '../../assets/svg/Pregledi/Propisi.svg';
import { ReactComponent as PropisiPoMinistarstvima } from '../../assets/svg/Pregledi/PropisiPoMinistarstvima.svg';
import { ReactComponent as PropisiPoPoglavljima } from '../../assets/svg/Pregledi/PropisiPoPoglavljima.svg';
import { ReactComponent as PropisiPoKlasterima } from '../../assets/svg/Pregledi/PropisiPoKlasterima.svg';
import { ReactComponent as MereKapaciteta } from '../../assets/svg/Registri/MereKapaciteta.svg';
import { ReactComponent as PretrazivanjePropisa } from '../../assets/svg/Registri/PretrazivanjePropisa.svg';
import { ReactComponent as UpravljanjeFinansijskihIzvestaja } from '../../assets/svg/Registri/UpravljanjeFinansijskihIzvestaja.svg';
import { ReactComponent as KvartalnaStatistika } from '../../assets/svg/Pregledi/KvartalnaStatistika.svg';
import { ReactComponent as Statistika } from '../../assets/svg/Pregledi/Statistika.svg';

function Views() {
	let navigate = useNavigate();
	const location = useLocation();
	const [screen, setScreen] = useState('default');

	const screenMap = {
		search: <SearchRegister />,
		celexInstitution: <CelexInstitutionView />,
		celexChapter: <CelexNPIView />,
		quartalView: <QuartalView />,
	};
	const menuList = [
		// {
		//   name: 'Претраживање',
		//   subMenus: [{ name: 'searchRegister', title: 'NPAA', url: 'search' }],
		// },
		{
			name: 'Прописи са CELEX-има',
			icon: <Propisi />,
			subMenus: [
				{
					name: 'celexInstitution',
					title: 'По министарствима и посебним организацијама',
					url: '/views/celexinstitution',
					icon: <PropisiPoMinistarstvima />,
				},
				{
					name: 'celexChapter',
					title: 'По преговарачким поглављима',
					url: '/views/celexchapter',
					icon: <PropisiPoPoglavljima />,
				},
				{
					name: 'celexCluster',
					title: 'По кластерима',
					url: '/views/celexcluster',
					icon: <PropisiPoKlasterima />,
				},
			],
		},
		{
			name: 'Мере, Капацитети и Финансијски аспекти усклађивања са ЕУ законодавством',
			icon: <MereKapaciteta />,
			subMenus: [
				{ name: 'measures', title: 'Преглед мера', url: '/views/measures', icon: <PretrazivanjePropisa /> },
				{
					name: 'fin',
					title: 'Преглед издатака/извора финансирања',
					url: '/views/fin',
					icon: <UpravljanjeFinansijskihIzvestaja />,
				},
			],
		},
		{
			name: 'Квартална реализ. и статистика',
			icon: <KvartalnaStatistika />,
			subMenus: [
				{
					name: 'quartalView',
					title: 'По министарствима и посебним организацијама',
					url: '/views/quartalview',
					icon: <Statistika />,
				},
			],
		},
		// {
		//   name: 'НПАА Прописи',
		//   subMenus: [
		//     {
		//       name: 'pl22-25',
		//       title: 'Пл.прописи 2022-2025 NPAA',
		//       url: 'npaa/pl22-25',
		//     },
		//     {
		//       name: 'pl-sub22-25',
		//       title: 'Пл.под. акта 2022-2025 NPAAA',
		//       url: 'npaa/pl-sub22-25',
		//     },
		//     {
		//       name: 'pl-sub16-18',
		//       title: 'Пл.под. акта 2016-2018 NPAA',
		//       url: 'npaa/pl-sub16-18',
		//     },
		//     {
		//       name: 'pl16-18',
		//       title: 'Пл.прописи 2016-2018 NPAA',
		//       url: 'npaa/pl16-18',
		//     },
		//     {
		//       name: 'pl-sub13',
		//       title: 'Пл.под. акта 2013 NPAA',
		//       url: 'npaa/pl-sub13',
		//     },
		//     {
		//       name: 'pl13',
		//       title: 'Пл.прописи 2013 NPAA',
		//       url: 'npaa/pl13',
		//     },
		//   ],
		// },
	];
	return (
		<div className=' w-full h-full flex flex-row justify-start'>
			<Sidebar menuList={menuList} />
			<div className='w-full'>
				<Outlet />
			</div>
		</div>
	);
}

export default Views;
